const Face_0 = require('./0.gif')
const Face_1 = require('./1.gif')
const Face_2 = require('./2.gif')
const Face_3 = require('./3.gif')
const Face_4 = require('./4.gif')
const Face_5 = require('./5.gif')
const Face_6 = require('./6.gif')
const Face_7 = require('./7.gif')
const Face_8 = require('./8.gif')
const Face_9 = require('./9.gif')
const Face_10 = require('./10.gif')
const Face_11 = require('./11.gif')
const Face_12 = require('./12.gif')
const Face_13 = require('./13.gif')
const Face_14 = require('./14.gif')
const Face_15 = require('./15.gif')
const Face_16 = require('./16.gif')
const Face_17 = require('./17.gif')
const Face_18 = require('./18.gif')
const Face_19 = require('./19.gif')
const Face_20 = require('./20.gif')
const Face_21 = require('./21.gif')
const Face_22 = require('./22.gif')
const Face_23 = require('./23.gif')
const Face_24 = require('./24.gif')
const Face_25 = require('./25.gif')
const Face_26 = require('./26.gif')
const Face_27 = require('./27.gif')
const Face_28 = require('./28.gif')
const Face_29 = require('./29.gif')
const Face_30 = require('./30.gif')
const Face_31 = require('./31.gif')
const Face_32 = require('./32.gif')
const Face_33 = require('./33.gif')
const Face_34 = require('./34.gif')
const Face_35 = require('./35.gif')
const Face_36 = require('./36.gif')
const Face_37 = require('./37.gif')
const Face_38 = require('./38.gif')
const Face_39 = require('./39.gif')
const Face_40 = require('./40.gif')
const Face_41 = require('./41.gif')
const Face_42 = require('./42.gif')
const Face_43 = require('./43.gif')
const Face_44 = require('./44.gif')
const Face_45 = require('./45.gif')
const Face_46 = require('./46.gif')
const Face_47 = require('./47.gif')
const Face_48 = require('./48.gif')
const Face_49 = require('./49.gif')
const Face_50 = require('./50.gif')
const Face_51 = require('./51.gif')
const Face_52 = require('./52.gif')
const Face_53 = require('./53.gif')
const Face_54 = require('./54.gif')
const Face_55 = require('./55.gif')
const Face_56 = require('./56.gif')
const Face_57 = require('./57.gif')
const Face_58 = require('./58.gif')
const Face_59 = require('./59.gif')
const Face_60 = require('./60.gif')
const Face_61 = require('./61.gif')
const Face_62 = require('./62.gif')
const Face_63 = require('./63.gif')
const Face_64 = require('./64.gif')
const Face_65 = require('./65.gif')
const Face_66 = require('./66.gif')
const Face_67 = require('./67.gif')
const Face_68 = require('./68.gif')
const Face_69 = require('./69.gif')
const Face_70 = require('./70.gif')
const Face_71 = require('./71.gif')

const EMOIJS_DATA = {
  '[微笑]': {
    text: '',
    src: Face_0
  },
  '[嘻嘻]': {
    text: '',
    src: Face_1
  },
  '[哈哈]': {
    text: '',
    src: Face_2
  },
  '[可爱]': {
    text: '',
    src: Face_3
  },
  '[可怜]': {
    text: '',
    src: Face_4
  },
  '[挖鼻]': {
    text: '',
    src: Face_5
  },
  '[吃惊]': {
    text: '',
    src: Face_6
  },
  '[害羞]': {
    text: '',
    src: Face_7
  },
  '[挤眼]': {
    text: '',
    src: Face_8
  },
  '[闭嘴]': {
    text: '',
    src: Face_9
  },
  '[鄙视]': {
    text: '',
    src: Face_10
  },
  '[爱你]': {
    text: '',
    src: Face_11
  },
  '[泪]': {
    text: '',
    src: Face_12
  },
  '[偷笑]': {
    text: '',
    src: Face_13
  },
  '[亲亲]': {
    text: '',
    src: Face_14
  },
  '[生病]': {
    text: '',
    src: Face_15
  },
  '[太开心]': {
    text: '',
    src: Face_16
  },
  '[白眼]': {
    text: '',
    src: Face_17
  },
  '[右哼哼]': {
    text: '',
    src: Face_18
  },
  '[左哼哼]': {
    text: '',
    src: Face_19
  },
  '[嘘]': {
    text: '',
    src: Face_20
  },
  '[衰]': {
    text: '',
    src: Face_21
  },
  '[委屈]': {
    text: '',
    src: Face_22
  },
  '[吐]': {
    text: '',
    src: Face_23
  },
  '[哈欠]': {
    text: '',
    src: Face_24
  },
  '[抱抱]': {
    text: '',
    src: Face_25
  },
  '[怒]': {
    text: '',
    src: Face_26
  },
  '[疑问]': {
    text: '',
    src: Face_27
  },
  '[馋嘴]': {
    text: '',
    src: Face_28
  },
  '[拜拜]': {
    text: '',
    src: Face_29
  },
  '[思考]': {
    text: '',
    src: Face_30
  },
  '[汗]': {
    text: '',
    src: Face_31
  },
  '[困]': {
    text: '',
    src: Face_32
  },
  '[睡]': {
    text: '',
    src: Face_33
  },
  '[钱]': {
    text: '',
    src: Face_34
  },
  '[失望]': {
    text: '',
    src: Face_35
  },
  '[酷]': {
    text: '',
    src: Face_36
  },
  '[色]': {
    text: '',
    src: Face_37
  },
  '[哼]': {
    text: '',
    src: Face_38
  },
  '[鼓掌]': {
    text: '',
    src: Face_39
  },
  '[晕]': {
    text: '',
    src: Face_40
  },
  '[悲伤]': {
    text: '',
    src: Face_41
  },
  '[抓狂]': {
    text: '',
    src: Face_42
  },
  '[黑线]': {
    text: '',
    src: Face_43
  },
  '[阴险]': {
    text: '',
    src: Face_44
  },
  '[怒骂]': {
    text: '',
    src: Face_45
  },
  '[互粉]': {
    text: '',
    src: Face_46
  },
  '[心]': {
    text: '',
    src: Face_47
  },
  '[伤心]': {
    text: '',
    src: Face_48
  },
  '[猪头]': {
    text: '',
    src: Face_49
  },
  '[熊猫]': {
    text: '',
    src: Face_50
  },
  '[兔子]': {
    text: '',
    src: Face_51
  },
  '[ok]': {
    text: '',
    src: Face_52
  },
  '[耶]': {
    text: '',
    src: Face_53
  },
  '[good]': {
    text: '',
    src: Face_54
  },
  '[no]': {
    text: '',
    src: Face_55
  },
  '[赞]': {
    text: '',
    src: Face_56
  },
  '[来]': {
    text: '',
    src: Face_57
  },
  '[弱]': {
    text: '',
    src: Face_58
  },
  '[草泥马]': {
    text: '',
    src: Face_59
  },
  '[神马]': {
    text: '',
    src: Face_60
  },
  '[囧]': {
    text: '',
    src: Face_61
  },
  '[浮云]': {
    text: '',
    src: Face_62
  },
  '[给力]': {
    text: '',
    src: Face_63
  },
  '[围观]': {
    text: '',
    src: Face_64
  },
  '[威武]': {
    text: '',
    src: Face_65
  },
  '[奥特曼]': {
    text: '',
    src: Face_66
  },
  '[礼物]': {
    text: '',
    src: Face_67
  },
  '[钟]': {
    text: '',
    src: Face_68
  },
  '[话筒]': {
    text: '',
    src: Face_69
  },
  '[蜡烛]': {
    text: '',
    src: Face_70
  },
  '[蛋糕]': {
    text: '',
    src: Face_71
  }
}

export {
  EMOIJS_DATA,
  Face_0 as FACE_0,
  Face_1 as FACE_1,
  Face_2 as FACE_2,
  Face_3 as FACE_3,
  Face_4 as FACE_4,
  Face_5 as FACE_5,
  Face_6 as FACE_6,
  Face_7 as FACE_7,
  Face_8 as FACE_8,
  Face_9 as FACE_9,
  Face_10 as FACE_10,
  Face_11 as FACE_11,
  Face_12 as FACE_12,
  Face_13 as FACE_13,
  Face_14 as FACE_14,
  Face_15 as FACE_15,
  Face_16 as FACE_16,
  Face_17 as FACE_17,
  Face_18 as FACE_18,
  Face_19 as FACE_19,
  Face_20 as FACE_20,
  Face_21 as FACE_21,
  Face_22 as FACE_22,
  Face_23 as FACE_23,
  Face_24 as FACE_24,
  Face_25 as FACE_25,
  Face_26 as FACE_26,
  Face_27 as FACE_27,
  Face_28 as FACE_28,
  Face_29 as FACE_29,
  Face_30 as FACE_30,
  Face_31 as FACE_31,
  Face_32 as FACE_32,
  Face_33 as FACE_33,
  Face_34 as FACE_34,
  Face_35 as FACE_35,
  Face_36 as FACE_36,
  Face_37 as FACE_37,
  Face_38 as FACE_38,
  Face_39 as FACE_39,
  Face_40 as FACE_40,
  Face_41 as FACE_41,
  Face_42 as FACE_42,
  Face_43 as FACE_43,
  Face_44 as FACE_44,
  Face_45 as FACE_45,
  Face_46 as FACE_46,
  Face_47 as FACE_47,
  Face_48 as FACE_48,
  Face_49 as FACE_49,
  Face_50 as FACE_50,
  Face_51 as FACE_51,
  Face_52 as FACE_52,
  Face_53 as FACE_53,
  Face_54 as FACE_54,
  Face_55 as FACE_55,
  Face_56 as FACE_56,
  Face_57 as FACE_57,
  Face_58 as FACE_58,
  Face_59 as FACE_59,
  Face_60 as FACE_60,
  Face_61 as FACE_61,
  Face_62 as FACE_62,
  Face_63 as FACE_63,
  Face_64 as FACE_64,
  Face_65 as FACE_65,
  Face_66 as FACE_66,
  Face_67 as FACE_67,
  Face_68 as FACE_68,
  Face_69 as FACE_69,
  Face_70 as FACE_70,
  Face_71 as FACE_71
}
